const mutations = {
  STORE_CERTIFICATION_VERSIONS(state, payload = []) {
    state.certificationVersions = payload
  },
  SET_CERTIFICATION_HISTORY_REQUEST(state, requestToken = null) {
    state.certificationHistoryRequestToken = requestToken
  },
  SET_CERTIFICATION_VERSION_REQUEST(state, requestToken = null) {
    state.certificationVersionRequestToken = requestToken
  },
  SET_CERTIFICATION_EXAM_REQUEST(state, requestToken = null) {
    state.certificationExamRequestToken = requestToken
  },
  SET_CERTIFICATION_EXAM_BY_VERSION_REQUEST(state, requestToken = null) {
    state.certificationExamByVersionRequestToken = requestToken
  },
  SET_LAUNCH_CONFIGURATION_REQUEST(state, requestToken = null) {
    state.launchConfigurationRequestToken = requestToken
  },
  STORE_CERTIFICATION_HISTORY(state, payload = {}) {
    state.certificationHistory = payload.history || []
    state.certificationHistoryCertificationId = payload.certificationId || null
    state.certificationHistoryCertification = payload.certification || null
  },
  STORE_CERTIFICATION_VERSION(state, payload = null) {
    state.certificationVersion = payload
  },
  STORE_CERTIFICATION(state, payload = null) {
    state.certificationVersion.certification = payload
  },
  STORE_CERTIFICATION_EXAM(state, payload = null) {
    state.certificationExam = payload
  },
  STORE_LAUNCH_CONFIGURATION(state, payload = null) {
    state.launchConfiguration = payload
  },
}

export default mutations
